import { NSARouterMakerResult } from "namirasoft-account-react";
import { CategoryScopeInputRow, CategoryScopeRow } from "namirasoft-field";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface CategoryScopeEditPageProps extends NSARouterMakerResult, FieldProps
{
	isEdit: boolean;
}

interface CategoryScopeEditPageState { }

export default class CategoryScopeEditPage extends Component<CategoryScopeEditPageProps, CategoryScopeEditPageState>
{
	NSBoxString_Name = createRef<NSBoxString>();
	NSBoxTexArea_Description = createRef<NSBoxTextArea>();

	constructor(props: CategoryScopeEditPageProps)
	{
		super(props);
		this.state = {};
	}

	override render()
	{
		return (
			<FieldLayout<CategoryScopeRow, CategoryScopeInputRow>
				{...this.props}
				action={{
					description: this.props.isEdit ? "This section allows you to update the details of an existing category scope." : "This section allows you to add a new category scope by entering its details."
				}}
				pages={{
					entity: FieldEntities.category_scope(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let name = this.NSBoxString_Name.current?.getValue() ?? "";
										let description = this.NSBoxTexArea_Description.current?.getValue() ?? "";

										return {
											workspace_id: "",
											name,
											description,
											category_scope_category: [],
											category_scope_field: [],
											category_scope_tag: [],
										};
									},
									setRow: (row) =>
									{
										this.NSBoxString_Name.current?.setValue(row.name);
										this.NSBoxTexArea_Description.current?.setValue(row.description ?? "");
									}
								}
							}
						}
					}
				}}
			>
				<NSColumn>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Name}
							title="Name"
							required
							info={{ link: "https://namirasoft.com/field/console-guide/category-scope/#field-name" }}
							style={{ width: NSBox.width.double }}
						/>
					</NSRow>
					<NSBoxTextArea
						ref={this.NSBoxTexArea_Description}
						title="Description"
						required={false}
						style={{ width: NSBox.width.double }}
						info={{ link: "https://namirasoft.com/field/console-guide/category-scope/#field-description" }}
					/>
				</NSColumn>
			</FieldLayout>
		);
	}
}